import { DateTime } from 'luxon';

export const convertDateToHours = (date: string) =>  {
    return DateTime.fromISO(date, { zone: 'UTC' }).toFormat('HH:mm');
};
